import { render } from "./BioSection.vue?vue&type=template&id=5aa1bc78"
const script = {}

import "./BioSection.vue?vue&type=style&index=0&id=5aa1bc78&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__